import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NewPageService } from '../../new-page.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: false,
})
export class NotificationsComponent implements OnInit {
  @Input() message: any = {};
  @Input() messageLink: any = {};
  @Input() linkText: any = {};
  @Input() isAdmission: any = {};
  isAdmissionsOpen: boolean = false;
  constructor(private newPageService: NewPageService) {}

  ngOnInit(): void {
    //this.isAdmissionsOpen = this?.school?.quickActions?.admission;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['school'] && changes['school'].currentValue) {
    //   this.isAdmissionsOpen = this?.school?.quickActions?.admission;
    // }
  }
}
